import React from "react";

const ArrowDownIcon = (props: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>pulse-icon</title>
      <path
        d="M1 11.002h2.5c.378 0 .724-.213.894-.552l.793-1.575 1.343 5.368c.11.442.504.753.96.758.454.006.855-.297.975-.736l2.06-7.535 1.013 3.547c.123.43.515.726.962.725H15c.552 0 1-.447 1-1 0-.552-.448-1-1-1h-1.744l-1.794-6.276c-.123-.432-.52-.73-.968-.726-.45.003-.84.305-.96.738l-1.99 7.312L6.47 5.757c-.103-.405-.447-.703-.862-.748-.416-.045-.815.173-1.002.547L2.88 9.002H1c-.552 0-1 .448-1 1 0 .553.448 1 1 1z"
        fill="#667085"
        fillRule="evenodd"
      />
    </svg>
  );
};
export default ArrowDownIcon;
